import type { LocaleDictionary } from "@/i18n/types";

const nsDialogJA = {
  common: {
    backButton: "戻る",
    cancelButton: "キャンセル",
    completeButton: "完了",
  },
  inProgress: {
    defaultTitle: "処理中",
    defaultSubText: "完了するまでお待ち下さい...",
  },
  error: {
    codeLabel: "エラーコード",
    messageLabel: "エラーメッセージ",
  },
  offline: {
    title: "ネットワークエラー",
    message:
      "ネットワークがオフラインです。ネットワーク環境を確認してください。",
  },
  operationStatus: {
    waiting: "未実行",
    inProgress: "実行中",
    success: "成功",
    failed: "失敗",
  },
  bulk: {
    targetCount: ({ count }: { count: number }) => `対象: ${count} 件`,
    resultSummary: ({ success, failed }: { success: number; failed: number }) =>
      `成功: ${success} / 失敗: ${failed}`,
    abortedSuffix: "(途中停止)",
    stopOnFailureLabel: "失敗時に残りを停止",
    stoppingButton: "停止中...",
    stopButton: "途中停止",
    noTargetSelected: ({ operationName }: { operationName: string }) =>
      `${operationName}する対象が選択されていません。`,
    stoppedNotification: ({ operationName }: { operationName: string }) =>
      `${operationName}を途中で停止しました`,
    partialFailureNotification: ({
      operationName,
    }: {
      operationName: string;
    }) => `${operationName}で一部失敗しました`,
    completedNotification: ({ operationName }: { operationName: string }) =>
      `${operationName}が完了しました`,
  },
  memberSelection: {
    requiredMessage: "対象メンバーを選択してください",
  },
} satisfies LocaleDictionary;

export default nsDialogJA;
